$(function () {
  // var breakPoint = 944;
  var breakPoint = 1024;

  var options = {
    itemSelector: ".box",
    // use element for option
    columnWidth: ".grid-sizer",
    gutter: ".gutter-sizer",
    percentPosition: true,
    transitionDuration: 0,
  };

  $(".button_download").mouseover(function () {
    $(this).hide();
    $(this).parent().find(".docs_download").css("display", "inline-block");
    $(this)
      .parent()
      .mouseleave(function () {
        $(this).find(".docs_download").hide();
        console.log($(this).find(".button_download").css("display", "inline-block"));
      });
  });

  $(".searchKanton").click(function () {
    $(".zertifizierung-adresse").hide();

    if ($('select[name="canton"]').val() != "") {
      $("." + $('select[name="canton"]').val()).show();
    }

    return false;
  });

  $(".foerderung tr").click(function () {
    var link = $(this).find("a").attr("href");
    if (link.length) {
      window.open(link, "_blank");
    }
    event.preventDefault();
  });

  function initMasonry() {
    $(".grid-col2").masonry(options);
  }

  // audiojs.events.ready(function() {
  //   var as = audiojs.createAll();
  // });
  $("audio").audioPlayer();

  setTimeout(initMasonry, 10);

  newsletterForm();
  memberForm();
  partnerForm();
  partnerFormZusatz();
  agendaForm();
  searchForm();
  orderForm();
  orderCO2();

  $("select").not(".chosen-select").niceSelect();
  $(".chosen-select").chosen({
    width: "100%",
  });

  $(".hamburger").click(function () {
    $(this).toggleClass("is-active");
    if ($(this).hasClass("is-active")) {
      $("nav").show();
    } else {
      $("nav").hide();
    }
  });

  $(".main a, .meta a").click(function () {
    if ($(this).parent().find(".sub-wrapper").length && $(window).width() < breakPoint) {
      $(".sub_arrow").removeClass("is-active");
      $(".sub").removeClass("is-active");
      $(this).parent().find(".sub_arrow").addClass("is-active");
      $(this).parent().find(".sub").addClass("is-active");
      return false;
    }
    return true;
  });

  $(".sub_arrow").click(function () {
    // $('.sub_arrow').removeClass('is-active');
    // $(this).addClass('is-active');
    // $('.sub').removeClass('is-active');
    // $(this).parent().find('.sub').addClass('is-active');
    var item = this;
    $(".sub_arrow").each(function (index) {
      var sub_arrow = $(".sub_arrow")[index];
      if (item == sub_arrow) {
        $(sub_arrow).toggleClass("is-active");
        $(sub_arrow).parent().find(".sub").toggleClass("is-active");
      } else {
        $(sub_arrow).removeClass("is-active");
        $(sub_arrow).parent().find(".sub").removeClass("is-active");
      }
    });
  });

  function resizeHeader() {
    if ($(window).width() >= breakPoint) {
      $("nav").show(0);
      var xTra = $(".desktop-subnavigation").height() ? 54 : 0;
      // $(".header-push").height($("header").height() + xTra);
      $(".header-push").css("min-height", $("header").height() + xTra);
    } else {
      // $(".header-push").height($("header").height());
      $(".header-push").css("min-height", $("header").height());
    }
  }
  $(document).ready(resizeHeader);
  $(window).resize(resizeHeader);

  $(".icon_lang > a").click(function () {
    // $('.lang_switch').toggle(0);
    $(".metaItems").toggle(0);
    $(".langItem").toggleClass("show");
    return false;
  });

  $(".icon_lang > a").mouseover(function () {
    // $('.lang_switch').toggle(0);
    $(".metaItems").toggle(0);
    $(".langItem").toggleClass("show");
    return false;
  });

  $(".icon_search > a").mouseover(function () {
    $(".metaItems").show(0);
    $(".langItem").removeClass("show");
  });

  $(".meta").mouseleave(function () {
    if ($(window).width() >= breakPoint) {
      $(".metaItems").show(0);
      $(".langItem").removeClass("show");
    }
  });

  $(".sub").appendAround();

  $(".overlayLink").bind("click", openOverlay);

  $(".overlay .close").click(function () {
    $(".overlay").hide();
    $("html").removeClass("overlayIsActive");
  });

  $(".overlay .print").click(function () {
    var url = window.location.href;
    var printWindow = window.open(url, "Print", "left=200, top=200, width=950, height=500, toolbar=0, resizable=0");
    printWindow.addEventListener(
      "load",
      function () {
        printWindow.print();
        //printWindow.close();
      },
      true
    );
  });

  $(".overlay .facebook").click(function () {
    var url = window.location.href;
    var shareUrl = "https://www.facebook.com/sharer.php?u=" + url;
    // console.log(shareUrl);
    var myleft = 20;
    var mytop = 20;
    settings = "width=640,height=480,top=" + mytop + ",left=" + myleft + ",scrollbars=no,location=no,directories=no,status=no,menubar=no,toolbar=no,resizable=no,dependent=no";
    win = window.open(shareUrl, "FacebookShare", settings);
    win.focus();
  });

  $(".overlay .twitter").click(function () {
    var url = window.location.href;
    var shareUrl = "https://twitter.com/intent/tweet?url=" + url;
    // console.log(shareUrl);
    var myleft = 20;
    var mytop = 20;
    settings = "width=640,height=480,top=" + mytop + ",left=" + myleft + ",scrollbars=no,location=no,directories=no,status=no,menubar=no,toolbar=no,resizable=no,dependent=no";
    win = window.open(shareUrl, "TwitterShare", settings);
    win.focus();
  });

  $(".overlay .email").click(function () {
    var url = window.location.href;
    var shareUrl = "mailto:?subject=Menerige Schweiz&body=" + url;
    var myleft = 20;
    var mytop = 20;
    settings = "width=640,height=480,top=" + mytop + ",left=" + myleft + ",scrollbars=no,location=no,directories=no,status=no,menubar=no,toolbar=no,resizable=no,dependent=no";
    win = window.open(shareUrl, "TwitterShare", settings);
    win.focus();
  });

  $(".overlay .share").click(function () {
    $(this).toggleClass("active");
    $(this).find("ul").toggle();
    if ($(this).hasClass("active")) {
      $(this).find("img").attr("src", "/templates/assets/images/ic_share_c.svg");
    } else {
      $(this).find("img").attr("src", "/templates/assets/images/ic_share.svg");
    }
  });

  $(".txt_content_col2.counter").each(function ($index) {
    $c = $index + 1;
    $(this)
      .find("li")
      .addClass("c" + $c);
  });

  if ($(".archive-wrapper")) {
    var archives = $(".archive");
    $(".archive-wrapper").html(archives);

    $(".accordion-btn").click(function () {
      $(this).parent().parent().toggleClass("active");
      return false;
    });
  }

  $(".slideshow").slick({
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: false,
    autoplaySpeed: 4000,
    cssEase: "ease",
  });

  $(".quote_slider").slick({
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "ease",
    arrows: false,
    fade: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
  });

  $(".moreFields, .lessFields").click(function () {
    $(this).parent().parent().parent().toggleClass("showMore");
  });

  $(".showKurse").bind("click", function () {
    if ($(this).find("input").is(":checked")) {
      $(".extra-fields.kurse").show();
    } else {
      $(".extra-fields.kurse").hide();
    }
  });

  $(".showVeranstaltungen").bind("click", function () {
    if ($(this).find("input").is(":checked")) {
      $(".extra-fields.veranstaltungen").show();
    } else {
      $(".extra-fields.veranstaltungen").hide();
    }
  });
});

$(window).on("load", function (e) {
  $("html").addClass("load");
});

function orderForm() {
  $(".accordeon_grey:not(.disabled) h5").click(function () {
    $(this).parent().toggleClass("active");
  });

  $(".input_group input").on("keyup", function () {
    var val = $(this).val();
    var max = $(this).data("max");
    if (!isNaN(val) && val > max) {
      $(this).val(max);
    } else if (isNaN(val)) {
      $(this).val(0);
    }
  });

  $(".order_options .checkbox.active").parent().find(".input_group").show();

  $(".order_options .checkbox").click(function () {
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      $(this).parent().find(".input_group").show();
    } else {
      $(this).parent().find(".input_group").hide();
      $(this).parent().find(".input_group input").val("");
    }
  });

  $(".order_form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "/templates/includes/order_form.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".order_form, .form_info").hide();
        },
      });
    }
    return false;
  });
}

function orderCO2() {
  $(".co2_form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "/templates/includes/co2_form.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".co2_form, .form_info").hide();
        },
      });
    }
    return false;
  });
}

function memberForm() {
  $('select[name="art_mietglied"]').change(function () {
    if ($(this).val() == "Einzelperson (200.- pro Jahr)") {
      $(".group_privat").show();
      $(".group_firma").hide();
      $(".require_firma").removeAttr("required");
      $(".require_privat").attr("required", "required");
    } else {
      $(".group_privat").hide();
      $(".group_firma").show();
      $(".require_privat").removeAttr("required");
      $(".require_firma").attr("required", "required");
    }
  });

  $('input[name="show_website"]').change(function () {
    if ($(this).is(":checked") && $('input[name="website"]').val() == "" && $('input[name="website_privat"]').val() == "") {
      $(".feedback_webseite_error").show();
    } else {
      $(".feedback_webseite_error").hide();
    }
  });

  $(".member_form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "/templates/includes/member_form.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".member_form, .form_info").hide();
        },
      });
    }
    return false;
  });
}

function newsletterForm() {
  $(".newsletter-anmeldung form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "index.php?rex-api-call=newsletter", // redaxo/src/addons/project/boot.php
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          console.log(result);
          $(".feedback_success").hide();
          $(".feedback_error").hide();
          if (result.responseText == "SUCCESS") {
            $("form").hide();
            $(".feedback_success").show();
          } else {
            $(".feedback_error").show();
          }
        },
      });
    }
    return false;
  });
}

function partnerFormZusatz() {
  $(".partner_form_zusatz").on("submit", function (e) {
    var f = $(this);
    $(".pakete label").removeClass("parsley-error");
    if ($("input[name='paket_klassik']").not(":checked").length && $("input[name='paket_digital']").not(":checked").length) {
      $(".pakete label").addClass("parsley-error");
    }

    if (f.parsley().validate()) {
      if ($("input[name='paket_klassik']").not(":checked").length && $("input[name='paket_digital']").not(":checked").length) {
        console.log("error");
        return false;
      }

      $.ajax({
        url: "/templates/includes/partner_form_zusatz.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".partner_form_zusatz, .form_info").hide();
        },
      });
    }
    return false;
  });
}

function partnerForm() {
  $(".partner_form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "/templates/includes/partner_form.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".partner_form, .form_info").hide();
        },
      });
    }
    return false;
  });

  $(function () {
    $(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function (event) {
      var $option = $(this);
      var $dropdown = $option.closest(".nice-select");
      var oldSelectedValue = $dropdown.find(".selected").data("value");
      $dropdown.find(".selected").removeClass("selected");
      $option.addClass("selected");

      var text = $option.data("display") || $option.text();
      $dropdown.find(".current").text(text);
      $dropdown
        .prev("select")
        .find('option[value="' + oldSelectedValue + '"]')
        .attr("selected", false);
      $dropdown
        .prev("select")
        .find('option[value="' + $option.data("value") + '"]')
        .attr("selected", "true");
      $dropdown.prev("select").val($option.data("value")).change();
    });

    $('select[name="nachweis"]').change(function () {
      var index = $(this).prop("selectedIndex");
      $(".spezCat").hide();
      $(".spezCat").find("input").prop("required", false);
      $(".cat" + index).show();
      $(".chosen-select").val("").trigger("chosen:updated");
      $(".input.cat" + index)
        .find("input")
        .prop("required", true);
    });

    $('select[name="kategorie"]').change(function () {
      var index = $(this).prop("selectedIndex");
      $(".spezCat").hide();
      $(".spezCat").find("input").prop("required", false);
      $(".spezCat.cat" + index).show();
      $(".spezCat.chosen-select").val("").trigger("chosen:updated");
      $(".spezCat.input.cat" + index)
        .find("input")
        .prop("required", true);
    });

    $('select[name="fachnachweis"]').change(function () {
      var index = $(this).prop("selectedIndex");
      $(".spezCat2").hide();
      $(".spezCat2").find("input").prop("required", false);
      $(".fachp" + index).show();
      $(".input.fachp" + index)
        .find("input")
        .prop("required", true);
    });
  });
}

function searchForm() {
  $(".search_form").on("submit", function (e) {
    var f = $(this);
    var searchUrl = $(this).find(".searchurl").val();
    if (f.parsley().validate()) {
      $.ajax({
        url: searchUrl,
        data: f.serialize(),
        type: "post",
        dataType: "json",
        complete: function (result) {
          // console.log(result['responseText']);
          $(".searchResult").html(result["responseText"]);
        },
      });
    }
    return false;
  });
}

function agendaForm() {
  $(".agenda_form").on("submit", function (e) {
    var f = $(this);
    if (f.parsley().validate()) {
      $.ajax({
        url: "/templates/includes/agenda_form.php",
        data: f.serialize(),
        type: "get",
        dataType: "json",
        complete: function (result) {
          $(".feedback_success").show();
          $(".agenda_form, .form_info").hide();
        },
      });
    }
    return false;
  });
}

function openOverlay() {
  host = location.host;
  var url = $(this).attr("href");
  $(".overlay .content_holder").html("");
  $(".overlay .content_holder").load(url + " #content", function () {
    $(".showcase a").each(function () {
      if (~$(this).attr("href").indexOf("http://")) {
      } else {
        if (!$(this).parent().hasClass("pdf_download")) if ($(this).attr("target") != "_blank") $(this).addClass("overlayLink");
      }
    });

    $(".overlay.OpenLinksInOverlay a")
      .not(".overlayLink")
      .each(function () {
        if (~$(this).attr("href").indexOf("http://")) {
        } else {
          if (!$(this).parent().hasClass("pdf_download")) if ($(this).attr("target") != "_blank") $(this).addClass("overlayLink");
        }
      });

    $(".overlayLink").bind("click", openOverlay);
    $(document).trigger("enhance.tablesaw");
    // initSVG();
    $("select").not(".chosen-select").niceSelect();
    $(".chosen-select").chosen({
      width: "100%",
    });

    newsletterForm();
    memberForm();
    agendaForm();
    searchForm();
    partnerForm();
    partnerFormZusatz();
    orderForm();
    orderCO2();

    $(".foerderung tr").click(function () {
      var link = $(this).find("a").attr("href");
      if (link.length) {
        window.open(link, "_blank");
      }
      event.preventDefault();
    });

    $(".content_holder .slideshow").slick({
      dots: false,
      infinite: true,
      speed: 700,
      autoplay: true,
      autoplaySpeed: 4000,
      cssEase: "ease",
    });

    $(".quote_slider").slick({
      dots: false,
      infinite: true,
      speed: 700,
      autoplay: true,
      autoplaySpeed: 5000,
      cssEase: "ease",
      arrows: false,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      draggable: false,
    });
  });

  $("html").addClass("overlayIsActive");
  $(".overlay").show();
  history.pushState(null, null, url);

  window.onpopstate = function (event) {
    $(".overlay").hide();
    $("html").removeClass("overlayIsActive");
    return false;
  };

  return false;
}

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  // return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  return docViewBottom >= elemTop && docViewTop <= elemBottom;
}

function format(num) {
  var n = num.toString(),
    p = n.indexOf(".");
  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, function ($0, i) {
    return p < 0 || i < p ? $0 + " " : $0;
  });
}

$(window).scroll(function () {
  if ($(".zahlenticker").length && !$(".zahlenticker").hasClass("start") && isScrolledIntoView(".zahlenticker")) {
    $(".zahlenticker").addClass("start");

    $(".counter").each(function () {
      $(this)
        .prop("Counter", 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 3000,
            easing: "easeOutExpo",
            step: function (now) {
              $(this).text(format(Math.ceil(now)));
            },
          }
        );
    });

    $(".counter_noformat").each(function () {
      $(this)
        .prop("Counter", 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 3000,
            easing: "easeOutExpo",
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          }
        );
    });
    $(".counter_year").each(function () {
      $(this)
        .prop("Counter", new Date().getFullYear())
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 3000,
            easing: "easeOutExpo",
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          }
        );
    });
  }
});

setTimeout(function () {
  $(window).scroll();
}, 500);

$(function () {
  var lastScrollTop = 0,
    delta = 250;
  $(window).scroll(function () {
    var nowScrollTop = $(this).scrollTop();
    if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
      if (nowScrollTop > lastScrollTop) {
        // ACTION ON
        // SCROLLING DOWN
        // console.log('Scroll down');
        $("header").addClass("small");
      } else {
        // ACTION ON
        // SCROLLING UP
        // console.log('Scroll up');
        $("header").removeClass("small");
      }
      lastScrollTop = nowScrollTop;
    }
  });

  if (window.location.hash) {
    var id = window.location.hash.substr(1);
    $(window.location.hash).find("article > div").addClass("active");
    console.log($(window.location.hash).offset().top);
    window.scrollTo({
      top: $(window.location.hash).offset().top - 250,
    });
  }
});

$(function () {
  if ($(".eco-publish")) {
    $(".eco-publish form").on("submit", function () {
      var bauvorhaben = $('select[name="bauvorhaben"]').val();
      var nutzung = $('select[name="nutzung"]').val();
      var default_url = $(this).data("url");
      var pdf_url = default_url + "/" + bauvorhaben + "/" + nutzung + ".pdf";
      if (bauvorhaben && nutzung) window.open(pdf_url);
      return false;
    });
  }
});

/// Newsletter Modal
var tempLink;
function openNewsletterModal(e) {
  // var cookie = $.cookie("modalNewsletter");
  // console.log(Cookies.get('modalNewsletter'));

  if (Cookies.get("modalNewsletter_") == undefined) {
    $(".modal.newsletter").show();
    tempLink = $(e).attr("href");
    // Cookies.set('modalNewsletter', 'visit', { expires: 365 })
    return false;
  } else {
    return true;
  }
}

$(".modal").click(function (e) {
  if ($(e.target).hasClass("modal")) {
    $(".modal").hide();
    window.open(tempLink, "_blank");
  }
});

function getCookieValue(a) {
  var b = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}
